module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse-00f25a77.svg";